/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var tagDefaultProps = {
  closable: false,
  disabled: false,
  icon: void 0,
  shape: "square",
  size: "medium",
  theme: "default",
  variant: "dark"
};
var checkTagDefaultProps = {
  disabled: false,
  size: "medium"
};

export { checkTagDefaultProps, tagDefaultProps };
//# sourceMappingURL=defaultProps.js.map
